// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************/
/* Header & Toolbar Styles */
/********************************************************************************/
body {
  width: 100vw;
  height: 100vh;
  min-width: 100vw;
  min-height: 100vh;
  margin: 0px;
  /* Disable pull-to-refresh / scroll-to-reload on mobile browsers */
  overscroll-behavior: none;
}

.mindplot-div-container {
  width: 100%;
  height: 100%;
}

.wise-editor .popover {
  font-size: 13px;
  max-width: none;
}`, "",{"version":3,"sources":["webpack://./../editor/src/global-styled.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF,4BAA4B;AAC5B,iFAAiF;AACjF;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kEAAkE;EAClE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":["/********************************************************************************/\n/* Header & Toolbar Styles */\n/********************************************************************************/\nbody {\n  width: 100vw;\n  height: 100vh;\n  min-width: 100vw;\n  min-height: 100vh;\n  margin: 0px;\n  /* Disable pull-to-refresh / scroll-to-reload on mobile browsers */\n  overscroll-behavior: none;\n}\n\n.mindplot-div-container {\n  width: 100%;\n  height: 100%;\n}\n\n.wise-editor .popover {\n  font-size: 13px;\n  max-width: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
